<template>
  <div v-if="showMenu" :class="{ 'nav-item dropdown': title, 'drop-down-button': !title }">
    <a 
      v-if="title"
      class="nav-link dropdown-toggle" 
      href="#" 
      :id="'dropDown' + guid" 
      role="button" 
      data-toggle="dropdown" 
      aria-haspopup="true" 
      aria-expanded="false">
        {{title}}
    </a>
    <button
      v-else
      class="btn btn-sm btn-turquoise ml-4"
      type="button"
      :id="'dropDown' + guid"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <span class="menu-dropdown-title"></span>
      <span class="fa fa-ellipsis-v"></span>
    </button>
    <div :class="['dropdown-menu', {'dropdown-menu-right': !this.menuLeft}, {'dropdown-menu-left': this.menuLeft == true}]" :aria-labelledby="'dropDown' + guid">
      <div v-for="(value, key, groupIndex) in groupedItems" v-bind:key="key">
        <div v-if="groupHasVisibleItem(value)">
          <div class="dropdown-divider" v-if="groupIndex !== 0"></div>
          <div class="dropdown-group" v-if="key !== 'undefined'">{{key}}</div>
          <div v-for="(b) in value" v-bind:key="b.id" :class="{ 'dropdown-divider': b.text === 'divider'}">
            <div v-if="b.visible">
              <a
                v-if="b.text !== 'divider'"
                href="#"
                :class="['dropdown-item', b.buttonClass]"
                @click.prevent="() => itemClick(b)"
              >
                {{b.text}}
                <i v-if="b.external" class="ml-1 fa fa-external-link" />
              </a>
            </div>
          </div>          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import uuid from "uuid/v4";
import $ from "jquery";

export default {
  components: {},
  data() {
    return {
      guid: uuid()
    };
  },
  props: {
    items: {
      type: [String, Array],
      required: true,
      default: []
    },
    title: {
      type: String,
      required: false,
      default: null
    },
    menuLeft: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {   
    async itemClick(item) {
      let clickMethod = item.onClick || item.click || this.getParentProperty(item.id, null);
      await clickMethod();
    },
    groupHasVisibleItem(items) {
      return items.some(i => i.visible == true);
    }
  },
  computed: {
    groupedItems() {
      return _.groupBy(this.internalItems, x => x.group);
    },
    internalItems() {         
        const internalItems = [];

        this.items.forEach((definition, index) => {
          const isDefinitionString = _.isString(definition);
          const isDefinitionObject = _.isObject(definition);

          if (isDefinitionString) internalItems.push(convertStringToItem(definition, index));
          if (isDefinitionObject) internalItems.push(convertObjectToItem(definition, index));
        });

        return internalItems;
    },
    showMenu() {
      return this.internalItems.some(i => i.visible == true);
    }
  }
};

const convertStringToItem = (name) => 
{
  if (name === 'divider') {
    return {
      text: 'divider'
    }
  }

  let id = utils.toCamelCase(utils.removeSpecialCharacters(name || ""));

  return {
    id,
    text: name,
    visible: true
  };
}

const convertObjectToItem = (obj, index) => 
{
  const {
    id,
    name,
    text,
    group,
    external,
    visible
  } = obj;

  let item = null;

  if (!!name) item = convertStringToItem(name, index);
  if (!item) item = convertStringToItem(text, index);

  item.visible = true;

  if (_.isBoolean(obj.visible)) item.visible = obj.visible;
  if (_.isFunction(obj.visible)) {
    Object.defineProperty(item, "visible", {get: obj.visible});
  }

  return {
    ...item,
    ...obj
  }
}

</script>

<style lang="scss" scoped>
.nav-link {
  font-size: 0.8rem !important;
}

.dropdown-group {
  font-weight: bold;
  padding: 0.25rem 1.5rem 0.25rem 1rem;
  font-size: small;
}

.drop-down-button {
  margin: 0.7rem 0;
  font-size: 1.35rem;
}

.menu-dropdown-title {
  font-weight: 300;
}

.drop-down-button {
  text-align: right;
}

button {
  font-size: 0.9rem;
}

a {
  font-size: 0.9rem;
}
</style>


// WEBPACK FOOTER //
// src/framework/primitives/AmfDropdownMenu.vue